import React, { useState, useEffect, useRef } from "react";
import * as API from "../../api.js";
import {
  checkSubscriptionAndStorage,
  addUserAnalytic,
  updateOutTime,
  getPicstorkDefaultPlan,
  Popup,
} from "../../ReusableComponents/reusableFunctions";
import SideBarNew from "../../SideBarNew";
import { activesubscription } from "../../redux";
import { connect } from "react-redux";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
  ArcElement,
} from "chart.js";
import AppConstants from "../../AppConstants";
import {
  getActiveTeam,
  getFeaturesPermissions,
  PICSTORK_FEATURES,
} from "../../Teams";
import { ManageProjectAccess } from "../../Teams/ManageProjectAccess";
import TopBarNew from "../../TopBarNew.js";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import Search from "../../Icon/Search.png";
import TableView from "../../ReusableComponents/TableView/TableView.js";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon.js";
import whitePlus from "../../assets/Icons/whiteplus.png";
import CreateTower from "./CreateTower.js";
import { TowerCard } from "../../ReusableComponents/Tower Card/TowerCard.js";
import { useHistory } from "react-router-dom";
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js";
import DetailedReport from "./TowerDetailedReport";
import ImageSlider from "./TowerImageSlider";
import EditTowerStats from "./EditTowerStats.js";
import { useLocation } from "react-router-dom";
import KMLUploader from "./KMLUploader.js";

const Towers = (props) => {

  const [user, setUser] = useState({});
  const [type, setType] = useState("");
  const [projects, setProjects] = useState([]);
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [sidebarMode, setSidebarMode] = useState(
    props?.location?.state?.sidebarMode || "shrunk"
  );
  const [outId, setOutId] = useState("");
  const [selectedMangeAccessProject, setSelectedMangeAccessProject] =
    useState(false);
  const [selectedProjectData, setSelectedProjectData] = useState(undefined);
  const [showSubscriptionExpirePopup, setShowSubscriptionExpirePopup] =
    useState(false);
  const [key, setKey] = useState("");
  const [counts, setCounts] = useState(0);
  const [imageCollection, setImageCollection] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [tableState, setTableState] = useState({
    pageSize: 10,
    pageNumber: 1,
    orderBy: undefined,
    orderType: undefined,
  });
  const [globalState, setGlobalState] = useState({
    selectView: "list",
  });
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);

  const [detectionPollingTaskId, setDetectionPollingTaskId] = useState(null);
  const [pollingIntervalId, setPollingIntervalId] = useState(null);
  const [completedTasksMap, setCompletedTasksMap] = useState({});
  const [currentView, setCurrentView] = useState("main");
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [imageSliderData, setImageSliderData] = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [isLoadingTasks, setIsLoadingTasks] = useState(false);
  const [selectedDetected, setselectedDetected] = useState([]);
  const query = new URLSearchParams(useLocation().search);
  const fromDashBoard = query.get("fromDashBoard") === "true" || false;

  const handleStateChange = (key, value) => {
    setGlobalState((prev) => ({
      ...prev,
      [key]: value,
    }));

    if (key === "selectView" && value === "grid") {
      setTableState((prev) => ({
        ...prev,
        pageNumber: 1,
      }));
    }
  };

  const activities = {
    canEdit: true,
    onClickEdit: (row) => {
      setIsEditModalOpen(true);
      setSelectedProject(row);
    },
    canDelete: true,
    onClickDelete: (row) => console.log("Delete", row),
  };

  useEffect(() => {
    return () => {
      updateOutTime(outId);
      localStorage.removeItem("created_task");

      if (pollingIntervalId) {
        clearInterval(pollingIntervalId);
      }
    };
  }, [outId, pollingIntervalId]);

  useEffect(() => {
    document.title = "PicStork - Dashboard";
    ChartJS.register(
      BarElement,
      CategoryScale,
      ArcElement,
      LinearScale,
      PointElement,
      LineElement,
      Title,
      Tooltip,
      Legend,
      Filler
    );

    getActiveTeam().then((activeTeam) => {
      checkSubscriptionAndStorage(AppConstants.SERVICES.PICSTORK).then(
        (data) => {
          if (
            data.error ||
            data.storageExceed ||
            data.isExpired ||
            !data.isValidStoragePlan
          ) {
            setShowSubscriptionExpirePopup({
              ...data,
              user: props?.location?.state?.user,
            });
          } else {
            setShowSubscriptionExpirePopup(false);
          }
        }
      );

      addUserAnalytic(props.location.pathname).then((id) => {
        setOutId(id);
      });

      if (props.location.state) {
        const { user, type, sidebarMode } = props.location.state;
        setUser(user || {});
        setSidebarMode(sidebarMode || "shrunk");
        setType(type || "");

        API.getUserSubbedServices().then((response) => {
          let services = response[0];
          if (services.length === 1 && services[0].title === "AeroStream") {
            setShowBackIcon(false);
          } else {
            setShowBackIcon(true);
          }

        });
      } else {
        API.getUserType().then(
          ([blah, type, user]) => {
            setUser(user);
            setType(type);
          },
          () => {
            window.location.replace("/login");
          }
        );
      }
    });
  }, []);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const featuresList = [
          PICSTORK_FEATURES.IMAGECOLLECTIONS,
          PICSTORK_FEATURES.ANNOTATIONS,
          PICSTORK_FEATURES.TASKS,
          PICSTORK_FEATURES.REPORTS,
        ];

        const perms = await getFeaturesPermissions(featuresList);
        setPermissions(perms);
      } catch (error) {
        console.error("Error fetching permissions:", error);
        setPermissions({
          container: "",
          st: "",
          [PICSTORK_FEATURES.REPORTS]: { DOWNLOAD: true },
          [PICSTORK_FEATURES.TASKS]: { READ: true },
        });
      }
    };

    if (user?.username) {
      fetchPermissions();
    }
  }, [user]);

  const sidebarConfigurations = {
    options: showBackIcon
      ? [
        { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
        { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
      ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  const topbarConfigurations = {
    options: showBackIcon
      ? [
        fromDashBoard && {
          icon: MenuIcon,
          text: "Dashboard",
          path: "/picstork/dashboard",
        },
        { icon: MenuIcon, text: "Projects", path: "/picstork/towers" },
      ].filter(Boolean)
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  function useDebounce(value, delay = 500) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debounced;
  }

  const debouncedKey = useDebounce(key, 500);

  const columns = [
    { Header: "Name", accessor: "project_name", isSortable: true },
    {
      Header: "Created",
      accessor: "created_date",
      isSortable: true,
    },
    {
      Header: "Description",
      accessor: "description",
      isSortable: true,
    },
    {
      Header: "KML",
      accessor: "kmlimageurl",
      Cell: ({ row }) => {
        const kmlUrl = row?.original?.kmlimageurl;

        return (
          <div onClick={(e) => e.stopPropagation()}>
            {kmlUrl ? (
              <span >Added</span>
            ) : (
              <KMLUploader
                projectId={row.original.id}
                onUploadComplete={() => {
                  fetchProjects();
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      Header: "Orthomosaic",
      accessor: "orthomosaic",
    },
  ];

  const fetchProjects = async () => {
    try {
      setIsLoading(true);
      const pageNumber = Math.floor(tableState.pageNumber - 1);

      const response = await API.getAllProjects(
        key || " ",
        globalState.selectView == "list" ? 10 : 10000,
        pageNumber,
        null,
        "PicStork",
        null,
        null,
        tableState.orderBy,
        tableState.orderType
      );

      const formatted = (response.projects || response).map((p) => ({
        id: p.id,
        project_name: p.project_name,
        created_date: p.created_date
          ? new Date(p.created_date).toISOString().split("T")[0]
          : "—",
        description: p.description || "—",
        current_status: p.current_status ? p.current_status.charAt(0).toUpperCase() + p.current_status.slice(1).toLowerCase() : "-" || "—",
        total_installed: p.total_installed || "0",
        completed_towers: p.completed_towers || "0",
        in_progress_towers: p.in_progress_towers || "0",
        pending_towers: p.pending_towers || "0",
        energy: p.energy_consumed || "0",
        images: p.images || 0,
        detections: p.detections || 0,
        location: p.location_name || "—",
        capacity: p.capacity || "0",
        task_status: p.task_status,
        kmlimageurl: p.kmlimageurl,
      }));

      setProjects(formatted);
      setCounts(response.count || formatted.length);

      const map = {};
      await Promise.all(
        formatted.map(async (proj) => {
          try {
            const tasks = await fetchTasksForProject();

            const hasTasks = tasks.length > 0;
            const hasFailedTask = tasks.some(
              (task) => task.status === AppConstants.TASK.STATUS.FAILED
            );

            map[proj.id] = hasTasks && !hasFailedTask;
            if (tasks.length === 0) {
              map[proj.id] = false;
            } else {
              const firstTask = tasks[0];
              map[proj.id] =
                firstTask.status !== AppConstants.TASK.STATUS.FAILED;
            }
          } catch (err) {
            console.error(
              "Error checking completed tasks for project:",
              proj.id,
              err
            );
            map[proj.id] = false;
          }
        })
      );
      setCompletedTasksMap(map);
      if (history.location.search) {

        let projectData = formatted.find(p => p.id === params.get('id'))

        if (projectData) {
          handleRowClick(projectData)
        }
      }
    } catch (err) {
      console.error("Error fetching projects:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const updateProjectStats = async (data) => {
    try {
      let { completed, currentStatus, inProgress, pending, totalInstalled } =
        data;
      const response = await API.updateProjectStats(
        selectedProject.id,
        totalInstalled,
        completed,
        inProgress,
        pending,
        currentStatus
      );

      Popup.alert(
        "SUCCESS",
        response.message || "Project stats updated successfully",
        "OK",
        () => {
          fetchProjects();
          Popup.close();
        }
      );
      if (response) {
        console.log("Project stats updated successfully:", response);
      }
    } catch (error) {
      Popup.alert(
        "ERROR",
        error.message || "Error updating project stats",
        "OK",
        () => {
          Popup.close();
        }
      );
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [tableState, isCreateModalOpen, debouncedKey, globalState.selectView]);

  const fetchTasksForProject = async (projectId, planId) => {
    try {
      setIsLoadingTasks(true);
      const response = await API.getAllTask(
        projectId,
        planId,
        " ",
        0,
        100,
        "PicStork"
      );

      if (response && response.tasks) {
        setTasks(response.tasks);
        return response.tasks;
      }
      return [];
    } catch (err) {
      console.error("Error fetching tasks:", err);
      return [];
    } finally {
      setIsLoadingTasks(false);
    }
  };

  const handleDetect = async (projectRow) => {
    const plan = await getPicstorkDefaultPlan(projectRow);

    try {
      const projectId = projectRow.id;
      const projectName = (projectRow.project_name || "").toString();
      const safeName =
        `${projectName}`.replace(/\s+/g, "").slice(0, 40) || "PicstorkTask";
      const randomTwoDigit = Math.floor(10 + Math.random() * 90);
      const autoName = `${safeName}Task${randomTwoDigit}`;

      const payload = {
        task_name: autoName,
        taskType: "detection",
        project_id: projectId,
        project_name: projectName,
        plan_id: plan.id,
        state: 2,
        status: AppConstants.TASK.STATUS.CREATING,
        type: [],
      };

      const created = await API.createTask(payload);
      localStorage.removeItem("created_task");
      localStorage.setItem("created_task", JSON.stringify(created.task));

      const response = await API.getLatestImageSets(
        "project",
        100000,
        projectId,
        0,
        "PicStork"
      );

      if (response?.imageCollections?.length > 0) {
        const latestCollection = response.imageCollections[0];
        setImageCollection(response.imageCollections);

        await API.updateTaskDetails(created.task.task_id, {
          state: 3,
          models: [
            {
              "id": "c6f19d35-ecb7-4f2d-91a4-47fa6c37eb33",
              "name": "detectron2_img_Vegetation_encroachment123",
              "usable": true,
              "objects": [
                "Vegetation_encroachment"
              ],
              "display_name": "Tower_Vegetation_encroachment",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T13:05:32.256Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "d05bcde0-a6b8-4a17-aa10-8abfc6e37059",
              "name": "detectron2_img_U_Bolt",
              "usable": true,
              "objects": [
                "U_Bolt"
              ],
              "display_name": "Tower_U_Bolt",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T13:01:54.294Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "aef551d2-7ac2-4941-8a4f-c48a0f208e17",
              "name": "detectron2_img_Suspension_Clamp123",
              "usable": true,
              "objects": [
                "Suspension_Clamp",
                " Suspension_Clamp_Defect"
              ],
              "display_name": "Tower_Suspension_Clamp",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:59:17.393Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "a7b4d03a-43e9-4953-b21f-c42e59c1c36e",
              "name": "detectron2_img_Insulator123",
              "usable": true,
              "objects": [
                "Insulator"
              ],
              "display_name": "Tower_Insulator",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:56:48.858Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "f94ffa6c-f26c-43b8-947b-d9dd94fc1458",
              "name": "detectron2_img_Damper123",
              "usable": true,
              "objects": [
                "Damper"
              ],
              "display_name": "Tower_Damper",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:54:30.112Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "b1f09288-1c63-4718-8114-15ea76356ec5",
              "name": "detectron2_img_Corona_Ring123",
              "usable": true,
              "objects": [
                "Corona_Ring"
              ],
              "display_name": "Tower_Corona_Ring",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:50:38.535Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "69308950-90fe-445b-853e-5942e3dce1cb",
              "name": "detectron2_img_Foundation123",
              "usable": true,
              "objects": [
                "Foundation ",
                "Foundation_Cracks"
              ],
              "display_name": "Tower_Foundation",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:07:24.983Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            }
          ],
          collection_id: latestCollection.id,
          task_purpose: "Defect",
          linked_map: created.task.linked_map || null,
          task_parameters: {
            output_type: "BOX",
            measurement_type: null,
            dsm_url: null,
            dtm_url: null,
          },
          fps: created.task.fps || null,
        });

        await API.updateTaskDetails(created.task.task_id, {
          state: 4,
        });

        setselectedDetected((prev) => [...prev, projectRow.id]);

        await API.updateTask(
          created.task.task_id,
          AppConstants.TASK.STATUS.PENDING,
          AppConstants.SERVICES.PICSTORK
        );

        startPollingDetections(created.task.task_id, projectRow);
      }
    } catch (err) {
      console.error("Create detection task failed", err);
    }
  };



  const viewReports = async (projectRow) => {
    try {
      const tasks = await fetchTasksForProject();


      const completedTasks = tasks.filter(
        (task) => task.status === AppConstants.TASK.STATUS.COMPLETED
      );

      if (completedTasks.length > 0) {
        const latestTask = completedTasks[0];
        const completeTaskData = await API.getAeroCaptureTask(
          latestTask.task_id
        );

        setSelectedTask(completeTaskData);
        setSelectedProject(projectRow);
        setCurrentView("detailed");
      } else {
        console.error("No completed detection tasks found for this project");
      }
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
  };

  const startPollingDetections = (taskId, projectData) => {
    if (pollingIntervalId) {
      clearInterval(pollingIntervalId);
    }

    const intervalId = setInterval(async () => {
      try {
        const taskStatus = await API.getAeroCaptureTask(taskId);

        if (
          taskStatus.status === AppConstants.TASK.STATUS.COMPLETED &&
          taskStatus.state === 4
        ) {
          clearInterval(intervalId);

          const completeTaskData = await API.getAeroCaptureTask(taskId);

          setSelectedTask(completeTaskData);
          setSelectedProject(projectData);
          setCurrentView("detailed");
        } else if (taskStatus.status === AppConstants.TASK.STATUS.FAILED) {
          clearInterval(intervalId);
          console.error(`Task ${taskId} failed`);
        }
      } catch (err) {
        console.error(`Error polling task ${taskId}:`, err);
      }
    }, 30000);

    setPollingIntervalId(intervalId);
    setDetectionPollingTaskId(taskId);
  };

  const changeView = (type, data) => {
    if (type === 1) {
      setCurrentView("main");
      setSelectedTask(null);
      setSelectedProject(null);
      setSelectedPlan(null);
      setImageSliderData(null);
    } else if (type === 3) {
      setCurrentView("imageSlider");
      setImageSliderData(data);
    }
  };

  const handleRowClick = async (row) => {
    try {
      const tasks = []

      const hasCompletedTask = tasks.some(
        (task) => task.status === AppConstants.TASK.STATUS.COMPLETED
      );
      if (hasCompletedTask) {
        await viewReports(row);
      } else {
        history.push(`/picstork/upload-tower-images/?id=${row.id}`, {
          rowData: row,
        });
      }
    } catch (err) {
      console.error("Error handling row click:", err);
      history.push("/picstork/upload-tower-images", { rowData: row });
    }
  };

  return user?.username ? (
    <div className="wrapper">
      <ManageProjectAccess
        projectId={selectedMangeAccessProject}
        closeManageAccess={() => {
          setSelectedMangeAccessProject(false);
          setSelectedProjectData(undefined);
        }}
        senderData={user}
        propsData={selectedProjectData}
      />

      <SideBarNew
        config={sidebarConfigurations}
        showMainDashboardIcons={showBackIcon}
        parentSidebarSwitch={() =>
          setSidebarMode(sidebarMode === "shrunk" ? "expanded" : "shrunk")
        }
      />

      <div
        className="right-content"
        style={{ backgroundColor: "#EAEDF0" }}
        onClick={() => setSidebarMode("shrunk")}
      >
        <TopBarNew config={topbarConfigurations} />

        <div
          className="main-content"
          style={{
            background: "none",
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
            height: "calc(100vh - 80px)",
          }}
        >
          {currentView === "imageSlider" ? (
            <ImageSlider
              permissions={permissions}
              data={imageSliderData}
              onClassListUpdated={(classes) => {
                // Handle class updates if needed
                console.log("Classes updated:", classes);
              }}
              changeView={changeView}
            />
          ) : currentView === "detailed" ? (
            // Detailed Report View
            <div
              style={{
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "8px",
              }}
            >
              <DetailedReport
                permissions={permissions}
                user={user}
                type={type}
                task={selectedTask}
                plan={selectedPlan}
                project={selectedProject}
                changeView={changeView}
              />
            </div>
          ) : (
            <>
              <div
                className="slide"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  alignItems: "center",
                  // paddingRight: "25px",
                }}
              >
                {params.get("id") ? (
                  <></>
                ) : (
                  <>
                    <div
                      className="services-content-title"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        color: "#1F1C45",
                        fontWeight: 600,
                      }}
                    >
                      Projects ({counts})
                      <ButtonWithIcon
                        text=""
                        icon={whitePlus}
                        onClick={() => setIsCreateModalOpen(true)}
                        isDisabled={false}
                        backgroundColor="#2989CF"
                        border="1px solid #2989CF"
                      />
                    </div>

                    <CreateTower
                      isOpen={isCreateModalOpen}
                      onRequestClose={() => setIsCreateModalOpen(false)}
                      onSubmit={(newTower) => {
                      }}
                    />

                    {isEditModalOpen && (
                      <EditTowerStats
                        isOpen={isEditModalOpen}
                        initialData={selectedProject}
                        onRequestClose={() => setIsEditModalOpen(false)}
                        onSubmit={(updatedTower) => {
                          updateProjectStats(updatedTower);
                        }}
                      />
                    )}

                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        paddingRight: "8px",
                      }}
                    >
                      <div style={{ margin: "0px 5px" }}>
                        <img
                          src={Search}
                          style={{
                            height: "20px",
                            width: "20px",
                            position: "relative",
                            left: "25px",
                          }}
                        />
                        <input
                          type="text"
                          value={key}
                          className="add-user-form-text2"
                          placeholder="Search"
                          style={{
                            height: "30px",
                            width: "230px",
                            paddingLeft: "28px",
                            border: "1px solid rgba(102, 102, 102, 0.3)",
                          }}
                          onChange={(e) => setKey(e.target.value)}
                        />
                      </div>
                    </div>
                  </>
                )}
              </div>

              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "50px",
                  }}
                >
                  <LoaderComponent />
                </div>
              ) : globalState.selectView === "list" ? (
                <TableView
                  columns={columns}
                  data={projects}
                  isLoading={false}
                  showSrNo={true}
                  count={counts}
                  onStateChange={setTableState}
                  // activities={activities}
                  pageNumber={tableState.pageNumber}
                  onClickRow={(row) => {
                    // handleRowClick(row);
                    history.push(`/picstork/tower-plans`, {
                      rowData: row,
                    });
                  }}
                />
              ) : (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
                    gap: "15px",
                    padding: "10px",
                    width: "100%",
                    boxSizing: "border-box",
                  }}
                >
                  {projects.map((tower, idx) => (
                    <TowerCard
                      title={tower.project_name}
                      date={new Date(tower.created_date).toLocaleDateString()}
                      // footerButtonText="Detect"
                      // footerButtonDisabled={completedTasksMap[tower.id]}
                      // footerButtonOnClick={() => handleDetect(tower)}
                      onClick={() => history.push(`/picstork/tower-plans`, {
                        rowData: tower,
                      })}
                      info={[

                        { label: "KML - ", value: "-" },
                        { label: "Orthomosaic - ", value: "-" },
                      ]}
                    />
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div />
  );
};

// Redux
const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

const mapStateToProps = (state) => ({
  SubscriptionData: state.subscription.subscriptionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Towers);
